class DcMegaMenu extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-dc-mega-tab]');
    this.panels = this.querySelectorAll('[data-dc-mega-panel]');

    this.tabs.forEach((tab) => {
      tab.addEventListener('mouseenter', this.activateTab);
      tab.addEventListener('focus', this.activateTab);
      tab.addEventListener('click', this.activateTab);
    });
  }

  activateTab = (event) => {
    const tab = event.currentTarget;
    const index = tab.getAttribute('data-dc-mega-tab');
    if (index == null) return;

    this.tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.getAttribute('data-dc-mega-panel') === index;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  };
}

if (!customElements.get('dc-mega-menu')) {
  customElements.define('dc-mega-menu', DcMegaMenu);
}

class DcMegaMenuDrawer extends HTMLElement {
  connectedCallback() {
    this.toggles = this.querySelectorAll('[data-dc-drawer-category]');
    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', this.onToggleClick.bind(this));
    });
  }

  onToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const toggle = event.currentTarget;
    const category = toggle.closest('.dc-mega-drawer__category');
    const panel = category?.querySelector('.dc-mega-drawer__panel');
    if (!category || !panel) return;

    const isOpen = category.classList.contains('is-open');

    this.querySelectorAll('.dc-mega-drawer__category').forEach((item) => {
      const itemToggle = item.querySelector('[data-dc-drawer-category]');
      const itemPanel = item.querySelector('.dc-mega-drawer__panel');
      item.classList.remove('is-open');
      itemToggle?.setAttribute('aria-expanded', 'false');
      if (itemPanel) itemPanel.hidden = true;
    });

    if (!isOpen) {
      category.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
  }
}

if (!customElements.get('dc-mega-menu-drawer')) {
  customElements.define('dc-mega-menu-drawer', DcMegaMenuDrawer);
}
